module.exports = __webpack_public_path__ + "img/one-stop.80421241.png";